import { ChangeDetectorRef } from '@angular/core';
import {
    addNavMenuSection,
    DataService,
    ModalService,
    NotificationService,
    Permission,
    registerBulkAction,
} from '@vendure/admin-ui/core';
import { TimeSlotListComponent } from './components/time-slot-list/time-slot-list.component';
import { DeleteTimeSlotsDocument, GetTimeSlotsDocument } from './generated-types';

export default [
    addNavMenuSection({
        id: 'holiday',
        label: 'Holiday Orders',
        icon: 'event',
        requiresPermission: Permission.UpdateSettings,
        items: [
            {
                id: 'time-slots',
                label: 'Time Slots',
                requiresPermission: Permission.UpdateSettings,
                icon: 'event',
                routerLink: ['/extensions/time-slots'],
            },
        ],
    }),
    registerBulkAction({
        location: 'time-slot-list',
        label: 'Delete',
        icon: 'trash',
        iconClass: 'is-danger',

        onClick: async ({ injector, selection, clearSelection }) => {
            const modalService = injector.get(ModalService);
            const dataService = injector.get(DataService);
            const notificationService = injector.get(NotificationService);
            const cdr = injector.get(ChangeDetectorRef);
            const component = injector.get(TimeSlotListComponent);

            const selectedIds = selection.map(item => item.id); // Get selected IDs

            if (selectedIds.length === 0) {
                return;
            }

            modalService
                .dialog({
                    title: 'Confirm  Delete',
                    body: `Are you sure you want to delete ${selectedIds.length} items?`,
                    buttons: [
                        { type: 'danger', label: 'Delete', returnValue: true },
                        { type: 'secondary', label: 'Cancel' },
                    ],
                })
                .subscribe(async confirmed => {
                    if (confirmed) {
                        dataService
                            .mutate(DeleteTimeSlotsDocument, { ids: selectedIds })
                            .subscribe(async () => {
                                notificationService.success('Deleted Successfully');
                                clearSelection();

                                dataService.query(GetTimeSlotsDocument).ref.refetch();
                                component.refresh();
                                cdr.detectChanges();
                            });
                    }
                });
        },
    }),
];
